<div class="autocomplete-content">
  <div class="astral-stack-l">
    <div class="astral-layout-item">
      <app-information-block [text]="'REPRESENTATIVE.MANAGER.MAIN_INFO' | translate"></app-information-block>
    </div>

    <div class="representatives-filter-table__field" cdkOverlayOrigin #autocompleteOrigin="cdkOverlayOrigin">
      <label class="representatives-filter-table__label" for="search-input">{{ 'REPRESENTATIVE.MANAGER.AUTOCOMPLETE_COMPONENT.HEADER' | translate }}</label>
      <input
        #autocompleteInput
        id="search-input"
        type="text"
        autocomplete="off"
        placeholder="{{ 'REPRESENTATIVE.MANAGER.AUTOCOMPLETE_COMPONENT.PLACEHOLDER' | translate }}"
        [formControl]="selectionControl"
        [required]="control.required ? true : null"
        (focus)="openPopup()"
        class="autocomplete-input"
      />
    </div>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="popupOpen"
    [cdkConnectedOverlayOrigin]="autocompleteOrigin"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayFlexibleDimensions]="true"
  >
    <div class="autocomplete-popup representatives-filter-table__popup" #autocompletePopup>
      <app-popup-list-view
        [columnDefinition]="columnDefinition"
        [itemsSource]="this.itemsSource"
        [buttonText]="'REPRESENTATIVE.MANAGER.CREATE_REPRESENTATIVE_BUTTON' | translate"
        buttonSize="small"
        (rowClick)="onRowClick($event)"
        (buttonClick)="onButtonClick()"
        (nextPage)="handleNextPage()"
      >
      </app-popup-list-view>
    </div>
  </ng-template>
</div>
